var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('PromoCarousel'),_c('PromoActions'),_c('PromoSales'),_c('PromoPayment'),(_vm.indexPage != null && _vm.salesItems != null)?_c('PromoSalesMap'):_vm._e(),_c('PromoSalesOther'),_c('PromoAbout'),(_vm.indexPage != null && _vm.salesItems != null)?_c('formPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }